<template>
  <div id="LoanCardex" :class="{ 'loan-cardex--modal-embed': isModalEmbed }">
    <loading v-if="loadingRender"></loading>

    <net-pa-list-page-card
      v-if="!isModalEmbed"
      :title="pageTitle"
      :description="pageDescription"
      :show-back="true"
    >
      <div class="loan-cardex-toolbar" dir="rtl">
        <div class="loan-cardex-toolbar__select-wrap">
          <label class="loan-cardex-field-label" for="cmbTaahodat">
            {{ selectLabel }}
          </label>
          <select
            v-if="IsLoad"
            id="cmbTaahodat"
            name="cmbTaahodat"
            class="loan-cardex-select"
            v-model="Resultcmb"
            @change="getCardex"
          >
            <option value="-1">-- {{ selectPlaceholder }} --</option>
            <option v-for="item in ListModel" :key="item.id" :value="item.id">
              {{ item.vcodeDesNo }} {{ item.nameFamily }}
            </option>
          </select>
        </div>
        <div class="loan-cardex-toolbar__actions">
          <button type="button" class="loan-cardex-pdf-btn" @click="GetPdf">
            <i class="fas fa-file-pdf" aria-hidden="true"></i>
            <span>خروجی PDF</span>
          </button>
        </div>
      </div>

      <div class="loan-cardex-table-wrap">
        <vue-bootstrap4-table
          :rows="rows"
          :columns="columns"
          :config="config"
          :classes="classes"
          id="Data"
        >
          <template slot="sort-asc-icon">
            <i class="fa fa-sort-up"></i>
          </template>
          <template slot="sort-desc-icon">
            <i class="fa fa-sort-down"></i>
          </template>
          <template slot="no-sort-icon">
            <i class="fa fa-sort"></i>
          </template>
          <template slot="empty-results">
            <p class="text-right">اطلاعاتی یافت نشد</p>
          </template>
          <template slot="Pay" slot-scope="props">
            <button
              v-if="Number(props.row.mandeGhest.replace(/,/g, '').replace(/\./g, '')) > 0"
              type="button"
              class="loan-cardex-add-pay-btn"
              @click="AddToCart(props.row, false)"
            >
              <i class="fas fa-cart-plus" aria-hidden="true"></i>
              افزودن به لیست پرداخت
            </button>
          </template>
          <template slot="vaziatGhesttxt" slot-scope="props">
            <span :class="statusClass(props.cell_value)" class="loan-cardex-status">
              <i :class="statusIcon(props.cell_value)" aria-hidden="true"></i>
              {{ props.cell_value }}
            </span>
          </template>
        </vue-bootstrap4-table>
      </div>
    </net-pa-list-page-card>

    <div v-else class="loan-cardex-modal" dir="rtl">
      <button
        type="button"
        class="loan-cardex-modal__close close"
        data-dismiss="modal"
        aria-label="بستن"
      >
        <span aria-hidden="true">&times;</span>
      </button>
      <div class="loan-cardex-modal__header">
        <h6 class="loan-cardex-modal__title">
          <i class="fas fa-hourglass-half ml-2"></i>
          جزئیات معوقات
        </h6>
        <p v-if="selectedTaahodatLabel" class="loan-cardex-modal__subtitle">
          {{ selectedTaahodatLabel }}
        </p>
      </div>

      <div class="loan-cardex-modal__table-wrap table-responsive">
        <vue-bootstrap4-table
          :rows="rows"
          :columns="columns"
          :config="config"
          :classes="modalTableClasses"
        >
          <template slot="sort-asc-icon">
            <i class="fa fa-sort-up"></i>
          </template>
          <template slot="sort-desc-icon">
            <i class="fa fa-sort-down"></i>
          </template>
          <template slot="no-sort-icon">
            <i class="fa fa-sort"></i>
          </template>
          <template slot="empty-results">
            <p class="loan-cardex-modal__empty">اقساط معوقه‌ای یافت نشد</p>
          </template>
          <template slot="vaziatGhesttxt" slot-scope="props">
            <span :class="statusClass(props.cell_value)" class="loan-cardex-status">
              <i :class="statusIcon(props.cell_value)" aria-hidden="true"></i>
              {{ props.cell_value }}
            </span>
          </template>
        </vue-bootstrap4-table>
      </div>
    </div>
  </div>
</template>
<script>
import NetPaListPageCard from '../Tools/NetPa/NetPaListPageCard.vue'
import VueBootstrap4Table from 'vue-bootstrap4-table'
import loading from '../Tools/NetPa/Loading.vue'
import html2pdf from 'html2pdf.js'
export default {
  data() {
    return {
      DataAxiosRow: {
        ArryfildValue: '',
        Method: 'Post',
        Action: 'LoanCardex',
        Token: this.$session.get('TokenNetPa'),
      },
      DataAxios_cmbTaahodat: {
        ArryfildValue: '',
        Method: 'Post',
        Action: 'ListTaahodat',
        Token: this.$session.get('TokenNetPa'),
      },
      DataAxios_SahebHesab: {
        ArryfildValue: '',
        Method: 'Post',
        Action: 'ListTaahodat/TaahodatSahebHesab',
        Token: this.$session.get('TokenNetPa'),
      },
      ListModel: null,
      IsLoad: false,
      Resultcmb: '-1',
      rows: [],
      columns: [
        {
          label: 'id',
          name: 'id',
          visibility: false,
        },
        {
          label: 'ردیف',
          name: 'row',
        },
        {
          label: 'تاریخ سررسید',
          name: 'tarixGhest',
        },
        {
          label: 'مبلغ قسط(ريال)',
          name: 'mablaghGhest',
        },
        {
          label: 'مبلغ پرداختی(ريال)',
          name: 'mabPardaxtShodeGhest',
        },
        {
          label: 'مانده قسط',
          name: 'mandeGhest',
        },
        {
          label: 'تاریخ پرداخت',
          name: 'tarixSanad',
          sort: true,
        },
        {
          label: 'وضعیت',
          name: 'vaziatGhesttxt',
        },
        {
          label: 'جریمه(ريال)',
          name: 'mabJarime',
          visibility: this.$session.get('CustCode') == 868 ? false : true,
        },
        {
          label: 'پرداخت',
          name: 'Pay',
          visibility: false,
        },
        {
          label: 'vaziatGhest',
          name: 'vaziatGhest',
          visibility: false,
        },
      ],
      config: {
        pagination: false,
        pagination_info: false,
        per_page_options: [10, 20, 30, 50, 100],
        show_refresh_button: false,
        show_reset_button: false,
        checkbox_rows: false,
        rows_selectable: true,
        card_title: '',
        card_mode: false,
        global_search: {
          placeholder: ' جستجو',
          visibility: true,
          case_sensitive: false,
          showClearButton: true,
          searchOnPressEnter: false,
          searchDebounceRate: 1000,
        },
      },
      classes: {
        table: 'table-bordered table-striped table-sm ',
      },
      modalTableClasses: {
        table: 'table table-hover loan-cardex-modal-table',
      },
      loadingRender: false,
      ListModelSahebHesab: null,
      mablaghKarmozd1: 0,
      mablaghKarmozd2: 0,
      mandeGhest: 0,
      TaahodatRow: null,
    }
  },
  components: {
    NetPaListPageCard,
    VueBootstrap4Table,
    loading,
  },
  computed: {
    pageTitle() {
      if (this.FilterMoavaghe && this.FilterMoavaghe == true) {
        return 'جزئیات معوقات'
      }
      return this.$GetIsAnbohSaz() == 'false' ? 'کاردکس تسهیلات' : 'کاردکس قرارداد'
    },
    pageDescription() {
      if (this.FilterMoavaghe && this.FilterMoavaghe == true) {
        return ''
      }
      if (this.$GetIsAnbohSaz() != 'false') {
        return ''
      }
      return 'از طریق این فرم میتوانید کاردکس تسهیلات خود را مشاهده نمائید'
    },
    selectLabel() {
      return this.$GetIsAnbohSaz() == 'false' ? 'انتخاب تسهیلات' : 'انتخاب قرارداد'
    },
    selectPlaceholder() {
      return this.selectLabel
    },
    isModalEmbed() {
      return this.FilterMoavaghe === true || this.FilterMoavaghe === 'true'
    },
    selectedTaahodatLabel() {
      if (this.modalSubtitle) return this.modalSubtitle
      if (!this.TaahodatRow) return ''
      const parts = []
      if (this.TaahodatRow.desNoe) parts.push(this.TaahodatRow.desNoe)
      if (this.TaahodatRow.vCode) parts.push(this.TaahodatRow.vCode)
      return parts.join(' — ')
    },
  },
  mounted() {
    this.syncPayColumnVisibility()
    if (typeof this.$GetAppsettingsAsync === 'function') {
      this.$GetAppsettingsAsync().finally(() => {
        this.syncPayColumnVisibility()
      })
    }

    if (!this.isModalEmbed) {
      this.$AutoCloseMenuForMobile()
      window.scrollTo(0, 0)
    }

    if (this.isModalEmbed && this.TaahodatId) {
      this.Resultcmb = this.TaahodatId
      this.getCmbCardex()
      return
    }

    const formData = new FormData()
    let info
    formData.append('wwwtblAzaId', this.$session.get('UserInfoNetPa').wwwtblAzaId)
    formData.append('wwwtblSarfaslTypeId', 1)
    this.DataAxios_cmbTaahodat.ArryfildValue = formData
    this.$PostFormData(this.DataAxios_cmbTaahodat)
      .then((data) => {
        this.IsLoad = true
        this.ListModel = data.filter((x) => x.mande > 0)
        this.Resultcmb = !this.TaahodatId ? this.ListModel[0].id : this.TaahodatId
        this.TaahodatRow = this.ListModel.find((x) => x.id == this.Resultcmb)

        this.getCmbCardex()
      })
      .finally(() => {
        const formData = new FormData()
        formData.append('wwwtblAzaId', this.$session.get('UserInfoNetPa').wwwtblAzaId)
        formData.append('wwwtblSarfaslTypeId', 1)
        this.DataAxios_SahebHesab.ArryfildValue = formData
        this.$PostFormData(this.DataAxios_SahebHesab).then((data) => {
          if (data.length > 0) {
            this.IsLoad = true
            this.ListModelSahebHesab = data
            for (let index = 0; index < this.ListModelSahebHesab.length; index++) {
              if (this.ListModelSahebHesab[index].mande > 0) {
                info = this.ListModelSahebHesab[index]
                this.ListModel.push(info)
              }
            }
          }
        })
      })
  },
  methods: {
    isPayColumnVisible() {
      const cardexPay = this.$GetIsCardexPay()
      return cardexPay === true || String(cardexPay).toLowerCase() === 'true'
    },
    getColumnByName(name) {
      return this.columns.find((column) => column.name === name)
    },
    syncPayColumnVisibility() {
      const payColumn = this.getColumnByName('Pay')
      if (!payColumn) return
      payColumn.visibility = this.isPayColumnVisible()
      this.columns = [...this.columns]
    },
    statusClass(value) {
      const map = {
        'پرداخت نشده': 'loan-cardex-status--primary',
        'سررسيد قسط': 'loan-cardex-status--info',
        'پرداخت نشده ديركرد': 'loan-cardex-status--danger',
        'زودتر پرداخت شده': 'loan-cardex-status--success',
        'به موقع پرداخت شده': 'loan-cardex-status--success',
        'ديرتر پرداخت شده': 'loan-cardex-status--warning',
      }
      return map[value] || 'loan-cardex-status--muted'
    },
    statusIcon(value) {
      const map = {
        'پرداخت نشده': 'fas fa-times-circle',
        'سررسيد قسط': 'fas fa-user-clock',
        'پرداخت نشده ديركرد': 'fas fa-hourglass-half',
        'زودتر پرداخت شده': 'fas fa-check-circle',
        'به موقع پرداخت شده': 'fas fa-user-clock',
        'ديرتر پرداخت شده': 'fas fa-check-circle',
      }
      return map[value] || 'fas fa-info-circle'
    },
    AddToCart(row, IsAccount) {
      if (Number(row.mandeGhest.replace(/,/g, '').replace(/\./g, '')) > 0) {
        this.TaahodatRow['SumGhabelPar'] = Number(row.mandeGhest.replace(/,/g, '').replace(/\./g, ''))
        this.$Netpa_AddToCart(this.TaahodatRow, 'Loan', 'کاردکس', true)
      } else {
        this.$mySweetDefaultTost(
          'عدم افزودن به لیست',
          'قسط انتخابی شما پرداخت گردیده و امکان اضافه شدن به لیست پرداخت وجود ندارد',
          'warning',
          3000,
        )
      }
    },
    applyCardexResult(data) {
      if (data.status == 'Ok') {
        let info
        let list = []

        if (typeof data == 'string') {
          data = JSON.parse(data)
          for (let index = 0; index < data.length; index++) {
            var element = data[index]
            for (var key in element) {
              var temp = JSON.parse(JSON.stringify(key))
              var newkey = temp.charAt(0).toLowerCase() + temp.slice(1)
              element[newkey] = element[key]
              element['row'] = index + 1
              delete element[key]
            }
          }
        }

        for (let index = 0; index < data.result.length; index++) {
          info = data.result[index]
          info['row'] = index + 1
          list.push(info)
        }
        this.rows = this.$FormatMablaghGrid(list)
        if (this.isModalEmbed) {
          this.rows = this.rows.filter(
            (x) =>
              Number(String(x.mandeGhest || '').replace(/,/g, '').replace(/\./g, '')) > 0 &&
              (x.vaziatGhest == 2 || x.vaziatGhest == 5),
          )
        } else if (this.FilterMoavaghe && this.FilterMoavaghe == true) {
          this.rows = this.rows.filter(
            (x) =>
              Number(x.mandeGhest.replace(/,/g, '').replace(/\./g, '')) > 0 &&
              (x.vaziatGhest == 2 || x.vaziatGhest == 5),
          )
        }
        this.$nextTick(() => {
          this.syncPayColumnVisibility()
        })
        return true
      }

      this.$mySweetDefaultTost(
        'عدم وجود اطلاعات',
        'اطلاعاتی یافت نشد ، فیلتر جستجوی خود را تغییر دهید',
        'warning',
        2000,
      )
      this.config.pagination = false
      this.rows = []
      return false
    },
    getCmbCardex() {
      if (this.Resultcmb > 0) {
        this.loadingRender = true

        const formData = new FormData()
        formData.append('TaahodatId', this.Resultcmb)
        formData.append('ShobeId', this.$session.get('UserInfoNetPa').wwwtblShobeId)
        this.DataAxiosRow.ArryfildValue = formData

        this.$PostFormData(this.DataAxiosRow)
          .then((data) => {
            this.applyCardexResult(data)
          })
          .finally(() => {
            this.loadingRender = false
          })
      }
    },
    getCardex() {
      if (this.ListModel) {
        this.TaahodatRow = this.ListModel.find((x) => x.id == this.Resultcmb) || null
      }
      this.getCmbCardex()
    },
    getCardexFromApiService(inputTId) {
      var data = {
        prm: [inputTId == null ? this.Resultcmb : inputTId],
        IsDataTable: false,
      }

      this.$PostDataAPISERVICE({
        ArryfildValue: data,
        Token: this.$session.get('TokenNetPa'),
      })
        .then((data) => {
          for (let index = 0; index < data.length; index++) {
            var element = data[index]
            for (var key in element) {
              var temp = JSON.parse(JSON.stringify(key))
              var newkey = temp.charAt(0).toLowerCase() + temp.slice(1)
              element[newkey] = element[key]
              element['row'] = index + 1
              delete element[key]
            }
          }

          this.rows = this.$FormatMablaghGrid(data)
        })
        .finally(() => {
          this.loadingRender = false
        })
    },
    GetPdf() {
      this.loadingRender = true
      const payColumn = this.getColumnByName('Pay')
      if (payColumn) payColumn.visibility = false
      var htmlObject = document.getElementById('Data')
      html2pdf(htmlObject, {
        jsPDF: { format: 'a4', orientation: 'portrait' },
      })
      setTimeout(this.Reload, 2000)
    },
    Reload() {
      this.loadingRender = false
      this.syncPayColumnVisibility()
    },
  },
  created() {
    if (this.wwwtblAzaId) {
      this.$session.set('UserFromLoan', [this.wwwtblAzaId, false])
    }
  },
  props: ['TaahodatId', 'wwwtblAzaId', 'FilterMoavaghe', 'modalSubtitle'],
}
</script>
<style>
#LoanCardex .loan-cardex-toolbar {
  display: flex;
  flex-wrap: nowrap;
  align-items: flex-end;
  justify-content: space-between;
  gap: 0.75rem 1rem;
  padding: 0.75rem 1rem 1rem;
  border-bottom: 1px solid #e8ecf1;
  box-sizing: border-box;
}

#LoanCardex .loan-cardex-toolbar__select-wrap {
  flex: 1 1 auto;
  min-width: 0;
  max-width: 28rem;
}

#LoanCardex .loan-cardex-toolbar__actions {
  flex: 0 0 auto;
  margin-inline-start: 0;
  margin-inline-end: 0;
}

#LoanCardex .loan-cardex-field-label {
  display: block;
  margin-bottom: 0.35rem;
  font-family: IRANSansWeb, Tahoma, Arial, sans-serif;
  font-size: 13px;
  font-weight: 600;
  color: #2a3f54;
}

#LoanCardex .loan-cardex-select {
  width: 100%;
  min-height: 42px;
  padding: 0.5rem 0.75rem 0.5rem 2.25rem;
  border: 1px solid #dce1e8;
  border-radius: 8px;
  background-color: #fff;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='8' viewBox='0 0 12 8'%3E%3Cpath fill='%232a3f54' d='M1.4.6 6 5.2 10.6.6 12 2l-6 6-6-6z'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: left 0.85rem center;
  background-size: 12px 8px;
  appearance: none;
  -webkit-appearance: none;
  font-family: IRANSansWeb, Tahoma, Arial, sans-serif;
  font-size: 13px;
  color: #2a3f54;
  cursor: pointer;
  box-sizing: border-box;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}

#LoanCardex .loan-cardex-select:focus {
  outline: none;
  border-color: #2a3f54;
  box-shadow: 0 0 0 2px rgba(42, 63, 84, 0.12);
}

#LoanCardex .loan-cardex-pdf-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.4rem;
  min-height: 42px;
  padding: 0.45rem 1rem;
  border: 1px solid #dce1e8;
  border-radius: 8px;
  background: #fff;
  color: #c72816;
  font-family: IRANSansWeb, Tahoma, Arial, sans-serif;
  font-size: 13px;
  font-weight: 600;
  line-height: 1.25;
  cursor: pointer;
  white-space: nowrap;
  box-sizing: border-box;
  transition: background 0.15s ease, border-color 0.15s ease;
}

#LoanCardex .loan-cardex-pdf-btn i {
  font-size: 14px;
}

#LoanCardex .loan-cardex-add-pay-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.35rem;
  padding: 0.35rem 0.75rem;
  border: 1px solid #5ea31e;
  border-radius: 6px;
  background: #fff;
  color: #55941a;
  font-family: IRANSansWeb, Tahoma, Arial, sans-serif;
  font-size: 12px;
  font-weight: 600;
  line-height: 1.25;
  cursor: pointer;
  white-space: nowrap;
  box-sizing: border-box;
  transition: background 0.15s ease, border-color 0.15s ease, color 0.15s ease;
}

#LoanCardex .loan-cardex-add-pay-btn i {
  font-size: 13px;
}

#LoanCardex .loan-cardex-add-pay-btn:hover,
#LoanCardex .loan-cardex-add-pay-btn:focus {
  outline: none;
  background: #55941a;
  border-color: #55941a;
  color: #fff;
}

#LoanCardex .loan-cardex-pdf-btn:hover {
  background: #fef5f5;
  border-color: rgba(199, 40, 22, 0.35);
}

#LoanCardex .loan-cardex-table-wrap {
  padding: 0.75rem 1rem 1rem;
  overflow: visible;
  box-sizing: border-box;
  min-width: 0;
}

#LoanCardex .loan-cardex-table-wrap .table {
  width: max-content;
  min-width: 100%;
  font-family: IRANSansWeb, Tahoma, Arial, sans-serif;
}

@media (max-width: 767px) {
  #LoanCardex .loan-cardex-toolbar {
    gap: 0.5rem;
    padding: 0.65rem 0.85rem 0.75rem;
  }

  #LoanCardex .loan-cardex-toolbar__select-wrap {
    max-width: none;
  }

  #LoanCardex .loan-cardex-pdf-btn {
    padding: 0.45rem 0.75rem;
  }

  #LoanCardex .loan-cardex-pdf-btn span {
    font-size: 12px;
  }
}

#LoanCardex.loan-cardex--modal-embed .loan-cardex-modal {
  background: #fff;
  text-align: right;
  position: relative;
}

#LoanCardex .loan-cardex-modal__close {
  position: absolute;
  top: 0.85rem;
  left: 0.85rem;
  z-index: 2;
  float: none;
  margin: 0;
  padding: 0;
  width: 32px;
  height: 32px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  background: rgba(42, 63, 84, 0.08);
  color: #2a3f54 !important;
  opacity: 1;
  text-shadow: none;
  font-size: 1.35rem;
  line-height: 1;
}

#LoanCardex .loan-cardex-modal__close:hover {
  background: rgba(42, 63, 84, 0.14);
  color: #1a2a3a !important;
}

#LoanCardex .loan-cardex-modal__header {
  padding: 1rem 1.15rem 0.85rem;
  border-bottom: 1px solid #e8ecf1;
}

#LoanCardex .loan-cardex-modal__title {
  margin: 0;
  font-size: 15px !important;
  font-weight: 700;
  color: #2a3f54;
  line-height: 1.5;
}

#LoanCardex .loan-cardex-modal__title .fa-hourglass-half {
  color: #d97706;
}

#LoanCardex .loan-cardex-modal__subtitle {
  margin: 0.5rem 0 0;
  font-size: 13px !important;
  font-weight: 600;
  color: #6c757d;
}

#LoanCardex .loan-cardex-modal__table-wrap {
  padding: 0.75rem 1rem 1rem;
}

#LoanCardex .loan-cardex-modal-table {
  margin-bottom: 0;
  font-size: 13px !important;
}

#LoanCardex .loan-cardex-modal-table thead th {
  background: #f0f2f5;
  color: #2a3f54;
  font-weight: 700;
  border-color: #e8ecf1;
  white-space: nowrap;
}

#LoanCardex .loan-cardex-modal-table tbody td {
  vertical-align: middle;
  color: #2a3f54;
}

#LoanCardex .loan-cardex-modal__empty {
  margin: 0;
  padding: 1.5rem 0;
  text-align: center;
  color: #6c757d;
}

#LoanCardex .loan-cardex-status {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  padding: 0.2rem 0.5rem;
  border-radius: 6px;
  font-size: 12px !important;
  font-weight: 600;
  white-space: nowrap;
}

#LoanCardex .loan-cardex-status--primary {
  color: #2563eb;
  background: rgba(37, 99, 235, 0.08);
}

#LoanCardex .loan-cardex-status--info {
  color: #0891b2;
  background: rgba(8, 145, 178, 0.08);
}

#LoanCardex .loan-cardex-status--danger {
  color: #c72816;
  background: rgba(199, 40, 22, 0.08);
}

#LoanCardex .loan-cardex-status--success {
  color: #28a745;
  background: rgba(40, 167, 69, 0.08);
}

#LoanCardex .loan-cardex-status--warning {
  color: #d97706;
  background: rgba(217, 119, 6, 0.1);
}

#LoanCardex .loan-cardex-status--muted {
  color: #6c757d;
  background: #f0f2f5;
}

#LoanCardex .vbt-search-wrapper {
  padding: 0.75rem 1rem 0;
  background: #fff;
}

/* جستجوی مدال معوق: عرض ثابت مثل دسکتاپ، نه تمام‌عرض موبایل */
#LoanCardex.loan-cardex--modal-embed .vbt-table-tools {
  --vbt-search-max-width: 20rem;
}

#LoanCardex.loan-cardex--modal-embed .vbt-table-tools .vbt-header-row {
  flex-wrap: nowrap;
  gap: 0.75rem;
}

#LoanCardex.loan-cardex--modal-embed .vbt-table-tools .vbt-header-row > .col-md-4:first-child {
  flex: 0 1 auto;
  max-width: min(100%, var(--vbt-search-max-width));
  width: auto;
  min-width: 12rem;
}

#LoanCardex.loan-cardex--modal-embed
  .vbt-table-tools
  .vbt-header-row
  > .col-md-4:first-child
  > .row.no-gutters {
  flex-wrap: nowrap;
  width: auto;
  max-width: 100%;
}

#LoanCardex.loan-cardex--modal-embed
  .vbt-table-tools
  .vbt-header-row
  > .col-md-4:first-child
  > .row.no-gutters
  > .col-md-6:first-child {
  flex: 0 1 auto;
  max-width: min(100%, var(--vbt-search-max-width));
  width: 100%;
}

#LoanCardex.loan-cardex--modal-embed .vbt-table-tools .vbt-global-search {
  width: 100%;
  max-width: min(100%, var(--vbt-search-max-width));
  margin-inline-start: auto;
  margin-inline-end: 0;
}

#LoanCardex.loan-cardex--modal-embed .vbt-table-tools .vbt-global-search .form-group,
#LoanCardex.loan-cardex--modal-embed .vbt-table-tools .vbt-global-search .form-control {
  width: 100%;
  max-width: min(100%, var(--vbt-search-max-width));
}

#LoanCardex.loan-cardex--modal-embed .vbt-table-tools .vbt-header-row > .col-md-8 {
  flex: 0 0 auto;
  max-width: none;
  width: auto;
  margin-top: 0;
}
</style>
